import { useState, useCallback } from "react";
import { useEnqueueSnackbar } from "../useEnqueueSnackbar";
import ScheduledReportsService from "../../services/ScheduledReportsService";
import apiClient from "../../auth/apiClient";

const scheduledReportsService = new ScheduledReportsService(apiClient);

export default function useScheduledReportsParameters(
  scheduledrptid,
  facilityID,
  facilityIDs,
  entityid,
) {
  const enqueueSnackbar = useEnqueueSnackbar();
  const [items, setItems] = useState([]);

  const getItems = useCallback(async (reportid) => {
    if (!reportid) {
      enqueueSnackbar("Invalid report ID", {
        variant: "warning",
        tag: "InvalidReportID",
      });
      return;
    }

    try {
      const response = await scheduledReportsService.getParametersbyReportId(
        reportid,
        scheduledrptid,
        facilityID,
        facilityIDs,
        entityid,
      );

      setItems(Array.isArray(response?.data) ? response.data : []);

      if (!response?.data?.length) {
        enqueueSnackbar("No parameters available", {
          variant: "warning",
          tag: "NoParametersAvailable",
        });
      }
    } catch (error) {
      enqueueSnackbar("Unable to retrieve parameters", {
        variant: "error",
        tag: "UnableToRetrieveParameters",
      });
    }
  }, [scheduledrptid, facilityID, facilityIDs, entityid, enqueueSnackbar]);

  return { items, getItems };
}
